/* eslint-disable default-param-last */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-danger */
/* eslint-disable no-use-before-define */
/* eslint-disable no-debugger */
/* eslint-disable no-lone-blocks */
/* eslint-disable react/destructuring-assignment */
import Icon from "@ant-design/icons";
import { Image, List, Tag, Tooltip } from "antd";
import dayjs from "dayjs";
import { get, isEmpty, isString, isUndefined, orderBy, uniqBy } from "lodash";
import React, { useState } from "react";
import { formatPhoneNumber, isValidPhoneNumber } from "react-phone-number-input";
import styled from "styled-components";
import CloseIconBlue from "../../../../static/icons/CloseIconBlue.svg";
import { TagColored } from "../../../library/basicComponents";
import { colorConfig } from "../../../library/colorConfig";
import { Colors, MESSAGE_CONTENT_TYPES } from "../../../library/constants";
import AntdIconV4 from "../../../utils/antdIcon";
import { convertUtcToLocal, formatBytes } from "../../../library/utils";

// Distance (px) from the top of the message list within which a scroll counts
// as "reached the top" and triggers loading the next older page. A strict
// `scrollTop === 0` check is unreliable because browsers report fractional
// scrollTop on high-DPI/zoomed displays and smooth/momentum scrolling rarely
// lands exactly on 0. Shared by the Activity Center and the browser extension.
export const SCROLL_TOP_FETCH_THRESHOLD = 5;

export const FilterTag = styled(TagColored)`
  background-color: ${props => (props.disabled ? Colors.lightGray : "none")};
  cursor: ${props => (props.disabled ? "not-allowed" : "default")} !important;
`;

/* eslint-disable no-else-return */
export const ConsentStatus = (consent, status) => {
  return `${
    consent === "ACCEPTED"
      ? "Opted-In"
      : consent === "PENDING" && status
      ? "Pending Consent"
      : consent === "PENDING" && !status
      ? "Implied Consent"
      : consent === "DECLINED"
      ? "Opted-Out"
      : "Send Consent"
  }`;
};

export const isConsentStatusEnable = (consent, status) => {
  return consent === "ACCEPTED" || ((consent === "PENDING" || consent === null) && !status);
};

export const SetContentBy = (item, userIdMap) => {
  // const user = item?.systemUserId
  //   ? userIdMap && userIdMap[item?.systemUserId]
  //   : userIdMap && userIdMap[item?.userId];
  return item?.content || "";
};

export const getLeadStatus = (user, status, msg, spinner = false) => {
  const ellipsisStatus = status.length > 15 ? `${status.substring(0, 12)}...` : status;
  if (spinner) {
    return <Tag color="#2db7f5" />;
  }
  if (
    status === "ACTIVE" ||
    status === "Open" ||
    status.toLowerCase().includes("active") ||
    status.toLowerCase().includes("new")
  ) {
    return user?.company?.crmIntegrationType === "SF" ? "Open" : ellipsisStatus;
    // : status.includes("ACTIVE")
    // ? "ACTIVE"
  } else if (status === "SOLD" || status === "Converted" || status.toLowerCase().includes("sold")) {
    return user?.company?.crmIntegrationType === "SF" ? "Converted" : ellipsisStatus;
    // : status.includes("SOLD")
    // ? "SOLD"
  } else if (status.includes("Contacted")) {
    return (
      <Tooltip placement="topLeft" title={msg || status}>
        <Tag color="#87d068">{ellipsisStatus.replace(/_/g, " ")}</Tag>
      </Tooltip>
    );
  } else {
    return (
      <Tooltip placement="topLeft" title={(msg || status).replace(/_/g, " ")}>
        <Tag color="#ff4500">{ellipsisStatus.replace(/_/g, " ")}</Tag>
      </Tooltip>
    );
  }
};

export const phoneIconColor = record => {
  const phoneObj = !isUndefined(
    record?.phoneNumbers && record?.phoneNumbers.length > 0 && record?.phoneNumbers[0]
  )
    ? record?.phoneNumbers[0]
    : {};
  const phoneType = phoneObj?.lookupType || "";
  if (["Invalid", "None"].includes(phoneType)) {
    return "red";
  }
  return colorConfig.secondaryDark;
};

export const displayPhone = (record, crmIntegration) => {
  const sortedPhones = orderBy(record?.phoneNumbers || [], "lookupType");
  const phoneObj =
    sortedPhones.find(item => item.isPrimary) ||
    sortedPhones.find(item => ["mobile", "voip"].includes(item.lookupType));
  const phoneType = phoneObj?.lookupType || "";
  const phone = phoneObj?.phone || "";
  if (!isEmpty(phone) && phone != null) {
    if (["Invalid", "None"].includes(phoneType)) {
      return <Tooltip title="Invalid phone number">{phone}</Tooltip>;
    } else if (isValidPhoneNumber(phone)) {
      return isValidPhoneNumber(phone) && formatPhoneNumber(phone);
    }
  }
  return "N/A";
};

export const displayEmail = record => {
  const emails = record?.emails || [];
  if (isEmpty(emails)) return "N/A";
  const primaryEmail = emails.find(e => e.isPrimary);
  return primaryEmail?.email || emails[0]?.email || "N/A";
};

export const displayContactInfo = (record, crmIntegration) => {
  const phone = displayPhone(record, crmIntegration);
  if (!isEmpty(record?.phoneNumbers) && phone !== "N/A") {
    return { type: "phone", value: phone };
  }
  const email = displayEmail(record);
  if (email !== "N/A") {
    return { type: "email", value: email };
  }
  return { type: "phone", value: "N/A" };
};

export const DealStatusIcon = ({ status, msg }) => {
  switch (status) {
    case "ACTIVE":
      return (
        <Tooltip placement="topLeft" title={msg}>
          <Tag className="m-0 p-0" color="green">
            Active
          </Tag>
        </Tooltip>
      );
    case "New":
      return (
        <Tooltip placement="topLeft" title={msg}>
          <Tag className="m-0 p-0" color="green">
            New
          </Tag>
        </Tooltip>
      );
    case "Open":
      return (
        <Tooltip placement="topLeft" title={msg}>
          <Tag className="m-0 p-0" color="blue">
            Open
          </Tag>
        </Tooltip>
      );
    case "SOLD":
      return (
        <Tooltip placement="topLeft" title={msg}>
          <Tag className="m-0 p-0" color="green">
            Lead Sold
          </Tag>
        </Tooltip>
      );
    case "Converted":
      return (
        <Tooltip placement="topLeft" title={msg}>
          <Tag className="m-0 p-0" color="green">
            Converted
          </Tag>
        </Tooltip>
      );
    case "ARCHIVED":
      return (
        <Tooltip placement="topLeft" title={msg}>
          Archived
        </Tooltip>
      );
    case "LOST":
      return (
        <Tooltip placement="topLeft" title={msg}>
          <Tag className="m-0 p-0" color="red">
            Lead Lost
          </Tag>
        </Tooltip>
      );
    default:
      return status;
  }
};

export const LeadStatus = (user, status, spinner = false) => {
  if (spinner) {
    return <Tag color="#2db7f5" />;
  }
  if ((status || "").toUpperCase().includes("ACTIVE") || status === "Open") {
    return (
      <>
        {" "}
        <Tag color="#2db7f5">
          {user?.company?.crmIntegrationType === "SF"
            ? "Open"
            : (status || "").includes("ACTIVE")
            ? "Active"
            : status}
        </Tag>
      </>
    );
  } else if ((status || "").toUpperCase() === "LOST") {
    return <Tag color="#cd201f">{status}</Tag>;
  } else if ((status || "").toUpperCase().includes("SOLD") || status === "Converted") {
    return (
      <>
        {" "}
        <Tag color="#87d068">
          {user?.company?.crmIntegrationType === "SF"
            ? "Converted"
            : (status || "").includes("SOLD")
            ? "Sold"
            : status}
        </Tag>
      </>
    );
  } else if ((status || "").toUpperCase() === "COMPLETED") {
    return (
      <>
        {" "}
        <Tag color="#87d068">{status}</Tag>
      </>
    );
  } else if ((status || "").includes("Contacted")) {
    return (
      <>
        {" "}
        <Tag color="#87d068">{status}</Tag>
      </>
    );
  } else if ((status || "").includes("Duplicate")) {
    return <Tag color="#cd201f"> {status}</Tag>;
  } else {
    return (
      <>
        {" "}
        <Tag color="#2db7f5">{status}</Tag>
      </>
    );
  }
};

export const handleOwnerCRM = leadUsers => {
  const ownerArray =
    leadUsers?.length > 0 &&
    leadUsers.map(user => {
      if (user?.userType?.name) {
        return {
          label: `${user?.userType?.name}`,
          username: `${user?.user?.firstName} ${user?.user?.lastName} ${
            user?.user?.companyRole?.name ? `(${user?.user?.companyRole?.name})` : ""
          }`,
        };
      } else {
        return {
          label: "",
          username: `${user?.user?.firstName} ${user?.user?.lastName} ${
            user?.user?.companyRole?.name ? `(${user?.user?.companyRole?.name})` : ""
          }`,
        };
      }
    });
  const leadOwnerList =
    ownerArray?.length > 0 &&
    ownerArray.map((owner, index) => (
      <div key={index}>
        <p style={{ marginBottom: "2px" }}>
          <strong style={{ fontSize: "13px" }}>{owner?.label ? `${owner?.label}: ` : ""}</strong>
          <Tag style={{ marginBottom: 5 }} color="green">
            <span>{owner?.username}</span>
          </Tag>
        </p>
      </div>
    ));

  return leadOwnerList;
};

export const leadOwners = (owners, crmIntegration = "") => {
  if (crmIntegration === "DS" || crmIntegration === "SF") {
    return handleOwnerCRM(owners);
  } else {
    let list = [];
    if (owners.length > 0) {
      list = owners.map((el, i) => {
        const fullName = `${el?.user?.firstName} ${el?.user?.lastName} ${
          el?.user?.companyRole?.name ? `(${el?.user?.companyRole?.name})` : ""
        }`;
        return (
          <Tooltip key={i} placement="topLeft" title={i === 0 ? "Primary Owner" : ""}>
            <Tag style={{ marginBottom: 5 }} color={i === 0 ? "purple" : "geekblue"}>
              {fullName}
            </Tag>
          </Tooltip>
        );
      });
    }
    return list;
  }
};

export const vehicles = lead => {
  let list = [];
  const vehiclesOfInterest = uniqBy(lead?.leadVehicleInventory || [], v =>
    [v.year, v.make, v.model].join()
  );
  if (vehiclesOfInterest.length > 0) {
    list = vehiclesOfInterest.map(el => {
      let voi = "";
      if (!isUndefined(el.make) && el.make !== null && el.make !== undefined && el.make !== 0)
        voi = `${voi} ${el.make} `;
      if (!isUndefined(el.model) && el.model !== null && el.model !== undefined && el.model !== 0)
        voi = `${voi} ${el.model} `;
      if (
        !isUndefined(el.year) &&
        +el.year !== 0 &&
        el.year !== null &&
        el.year !== undefined &&
        +el.year !== 0
      )
        voi = `${voi} ${el.year} `;

      return voi === "" || voi === 0 ? (
        <span>No Vehicles</span>
      ) : (
        <Tooltip
          placement="topLeft"
          title={el?.isCurrent ? "Previous/Current Vehicle" : "Vehicle of Interest"}
        >
          <Tag color={el?.isCurrent ? "magenta" : "blue"}>{voi}</Tag>
        </Tooltip>
      );
    });
  }
  const vehicleOfInterest = uniqBy(lead?.vehicleOfInterest || [], v =>
    [v.year, v.make, v.model].join()
  );
  if (vehicleOfInterest.length > 0) {
    vehicleOfInterest.map(el => {
      let voi = "";
      if (
        !isUndefined(el.year) &&
        +el.year !== 0 &&
        el.year !== null &&
        el.year !== undefined &&
        +el.year !== 0 &&
        el.year !== ""
      )
        voi = `${voi} ${el.year} `;
      if (
        !isUndefined(el.make) &&
        el.make !== null &&
        el.make !== undefined &&
        el.make !== 0 &&
        el.make !== ""
      )
        voi = `${voi} ${el.make} `;
      if (
        !isUndefined(el.model) &&
        el.model !== null &&
        el.model !== undefined &&
        el.model !== 0 &&
        el.model !== ""
      )
        voi = `${voi} ${el.model} `;
      {
        voi !== "" && voi !== 0
          ? list.push(
              <Tooltip
                placement="topLeft"
                title={el?.isCurrent ? "Previous/Current Vehicle" : "Vehicle of Interest"}
              >
                <Tag className="break-words" color={el?.isCurrent ? "magenta" : "blue"}>
                  {voi}
                </Tag>
              </Tooltip>
            )
          : list.push(<span>No Vehicles</span>);
      }
    });
  }
  return list;
};

export const ConsentColor = (consent, status) => {
  const color = `${
    consent === "ACCEPTED"
      ? "green"
      : consent === "PENDING" && status
      ? "orange"
      : consent === "PENDING" && !status
      ? "green"
      : consent === "DECLINED"
      ? "red"
      : colorConfig.primaryDark
  }`;
  return color;
};

export const ConsentIconType = (consent, status) => {
  return `${
    consent === "ACCEPTED"
      ? "CheckCircleOutlined"
      : consent === "PENDING" && status
      ? "ClockCircleOutlined"
      : consent === "PENDING" && !status
      ? "CheckCircleOutlined"
      : consent === "DECLINED"
      ? "CloseCircleOutlined"
      : "ExclamationCircleOutlined"
  }`;
};

export const Filter = ({ filter, remove }) => (
  <FilterTag>
    {filter.type === "Template" ? JSON.parse(filter.value).value : filter.value}
    <Icon className="ml-1" component={CloseIconBlue} onClick={() => remove(filter)} />
  </FilterTag>
);

export const ConsentStatusColor = (consent, status) => {
  return `${
    consent === "ACCEPTED"
      ? "#52c41a"
      : consent === "PENDING" && status
      ? "#ffbf00"
      : consent === "PENDING" && !status
      ? "#52c41a"
      : consent === "DECLINED"
      ? "#FC5A5A"
      : "#EEEEF1"
  }`;
};

// eslint-disable-next-line default-param-last
export const ShowConsent = (
  selectedLead,
  user,
  isFromChatbot = false,
  queryString,
  containerClassName
) => {
  let filterNumber = "";
  if (queryString) {
    [filterNumber] = (selectedLead?.phoneNumbers || [])?.filter(
      phone => phone?.phone === `+1${queryString}`
    );
  }
  const phone = filterNumber?.phone || selectedLead?.phoneNumbers?.[0]?.phone;
  const hasValidPhone = phone && !isEmpty(phone);

  // If no valid phone, try email
  if (!hasValidPhone) {
    const email = displayEmail(selectedLead);
    if (email !== "N/A") {
      return (
        <span className={`flex ${containerClassName || "justify-start"}`}>
          <span className={isFromChatbot ? "ml-0 text-xs" : ""}>{email}</span>
        </span>
      );
    }
  }

  return (
    <span className={`flex ${containerClassName || "justify-start"}`}>
      <span
        style={{ marginLeft: isFromChatbot ? "0px" : "", fontSize: isFromChatbot ? "12px" : "" }}
      >
        <Tooltip title={ConsentStatus(selectedLead?.textConsentStatus)}>
          {formatPhoneNumber(phone || "N/A")}
        </Tooltip>
      </span>
      <AntdIconV4
        type={ConsentIconType(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)}
        style={{
          color: ConsentStatusColor(selectedLead?.textConsentStatus),
          fontSize: isFromChatbot ? 15 : 20,
          marginLeft: 5,
          marginRight: "5px",
        }}
      />{" "}
    </span>
  );
};

export const CustomCalendar = styled.div`
  width: 45px;
  height: 45px;
  position: relative;
  background-color: ${props =>
    props.status === "error"
      ? colorConfig.cancelAppointement
      : props.status === "success"
      ? colorConfig.successAppointement
      : props.status === "default"
      ? "#0EA5E9"
      : props.status === "noshow"
      ? colorConfig.noShowAppointment
      : props.status === "show"
      ? colorConfig.primaryDark
      : colorConfig.schedualStatusAppointment};
  border-radius: 4px;
  color: ${colorConfig.WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-top: 10px;
`;

export const CalMonth = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  background-color: #007dae;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 15px;
  border-radius: 0 0 12px 12px;
  color: #fff;
  font-size: 13px;
`;

export const CalDate = styled.div`
  position: relative;
  bottom: 5px;
  span {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const ListItemWrap = styled(List)`
  border-left-style: solid;
  border-left-color: ${props => (props.stripcolor ? props.stripcolor : "#007dae")};
  border-left-width: 0.3rem;
  margin-bottom: 0.2rem;
  cursor: pointer;
`;

export const displayPhoneNumbers = phones => {
  const phoneNumbers = [];
  for (let i = 0; i < phones.length; i++) {
    const phoneObj = !isUndefined(phones[i]) ? phones[i] : {};
    const phoneType = phoneObj?.lookupType || "";
    const phone = phoneObj?.phone || "";
    if (!isEmpty(phone) && phone != null) {
      if (["Invalid", "None"].includes(phoneType)) {
        phoneNumbers.push(phone);
      } else if (isValidPhoneNumber(phone)) {
        phoneNumbers.push(formatPhoneNumber(phone));
      }
    }
  }
  const phoneStr = phoneNumbers.join(", ");
  return phoneStr;
};

const urlRegex = /(https?:\/\/[^\s)]+[^\s).])/g;

/**
 *
 * @param {string} text - Content from which the links will be parsed
 * @param {string} color - Link color, defaults to white
 * @returns JSX, to render the text with links inline
 */
export function renderLinks(text, color = "white") {
  const urls = text?.match(urlRegex);
  if (!urls) return text;

  const parts = text.split(urlRegex);
  const renderedText = parts.map((part, index) => {
    if (urls.includes(part)) {
      let href = part;

      // Strip trailing punctuation only for href, not display
      while (/[).,!?]$/.test(href)) {
        href = href.slice(0, -1);
      }

      return (
        <a
          href={href}
          style={{ color }}
          key={index}
          className="hover:!text-twLinkColor break-all grid underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      );
    }
    return part;
  });

  return renderedText;
}

/**
 * AI Response To Lead messages render through ReactMarkdown (for lists/
 * images/etc from the LLM output), not renderLinks() above. Plain
 * (non-markdown) URLs are a bare string as far as markdown is concerned,
 * so react-markdown (without the remark-gfm plugin, which this project
 * doesn't depend on) renders them as inert text instead of a clickable
 * link. Wraps any bare URL that isn't already inside markdown link syntax
 * into `[url](url)` so it renders through a markdown `a` renderer.
 *
 * @param {string} text - Markdown content that may contain bare URLs
 * @returns {string} Same text with bare URLs converted to markdown links
 */
export function linkifyPlainUrls(text) {
  if (!text) return text;
  return text.replace(urlRegex, (match, _p1, offset, fullString) => {
    const precedingChars = fullString.slice(Math.max(0, offset - 2), offset);
    // Already the target of a markdown link — e.g. "...text](https://...)" — leave as-is.
    if (precedingChars === "](") return match;
    return `[${match}](${match})`;
  });
}

export const TruncatedContent = ({ content, color = "white" }) => {
  const [showFullContent, setShowFullContent] = useState(false);
  const maxCount = 40;
  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  // Extract images from HTML content - handles all formats:
  // - Double quotes: src="..."
  // - Single quotes: src='...'
  // - No quotes: src=...
  // - Various URLs: http, https, data:, blob:, relative paths
  // - Case insensitive
  const extractImages = htmlContent => {
    if (!htmlContent) return [];
    // Match src with double quotes, single quotes, or no quotes
    const imgRegex = /<img[^>]*\ssrc\s*=\s*(?:"([^"]+)"|'([^']+)'|([^\s>]+))[^>]*>/gi;
    const matches = [...htmlContent.matchAll(imgRegex)];
    return matches.map(match => match[1] || match[2] || match[3]).filter(Boolean);
  };

  // Remove images from HTML content for separate rendering
  const removeImages = htmlContent => {
    if (!htmlContent) return "";
    return htmlContent.replace(/<img[^>]*>/gi, "");
  };

  const RenderContent = () => {
    const words = content.split(" ");
    const isTruncated = words.length > maxCount;
    const truncatedContent = isTruncated ? words.slice(0, maxCount).join(" ") : content;
    const displayContent = showFullContent ? content : truncatedContent;

    const images = extractImages(displayContent);
    const contentWithoutImages = removeImages(displayContent);

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: contentWithoutImages }} />
        {images.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            <Image.PreviewGroup>
              {images.map((src, index) => (
                <Image
                  key={index}
                  src={src}
                  width={150}
                  height={150}
                  style={{ objectFit: "cover", cursor: "pointer", borderRadius: 4 }}
                  fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgesAK+AOAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAZElEQVR4nO3BMQEAAADCoPVP7W0JoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeAN1xwABJxXfUgAAAABJRU5ErkJggg=="
                  preview={{
                    maskClassName: "rounded",
                  }}
                  placeholder={
                    <div
                      style={{
                        width: 150,
                        height: 150,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f5f5f5",
                        borderRadius: 4,
                      }}
                    >
                      Loading...
                    </div>
                  }
                />
              ))}
            </Image.PreviewGroup>
          </div>
        )}
        {isTruncated && (
          <span className="cursor-pointer text-blue-500" onClick={toggleContent}>
            {showFullContent ? "Show Less" : "Show More"}
          </span>
        )}
        {!showFullContent && isTruncated && <span> ...</span>}
      </div>
    );
  };

  return <RenderContent />;
};

export const eleadsLinkGenerator = leadFullName => {
  return `https://www.eleadcrm.com/evo2/fresh/elead-v45/elead_track/search/searchresults.asp?Go=2&searchexternal=&corpStore=false&st=0&lIUID=&etitle=&lDID=&PID=&origStrDo=&qs=true&q=${leadFullName.replace(
    / /g,
    "+"
  )}#`;
};

export const statusColor = (status, type = "text") => {
  if (status) {
    if (["bad", "lost"].includes(status?.toLowerCase())) {
      if (type === "class") {
        return "bg-red-100 text-red-600";
      }
      return "text-red-500";
    }
    if (["sold", "active"].includes(status?.toLowerCase())) {
      if (type === "class") {
        return "bg-green-100 text-green-600";
      }
      return "text-green-500";
    }
  }
  if (type === "class") {
    return "bg-blue-100 text-blue-600";
  }
  return "text-blue-500";
};
export const OppId = (opportunity, crmIntegration) => {
  if (crmIntegration === "EL") {
    const elObject =
      opportunity?.elLeadOpportunities?.length > 0 && opportunity?.elLeadOpportunities[0];
    return `${elObject.elOpportunityId || ""}`;
  }
  if (crmIntegration === "DS") {
    const dsObject =
      opportunity?.dsOpportunityEvents?.length > 0 && opportunity?.dsOpportunityEvents[0];
    return `${dsObject.dsEventId || ""}`;
  }
  if (crmIntegration === "SF") {
    const sfLeadOpportunity =
      opportunity?.sfLeadOpportunities?.length > 0 && opportunity?.sfLeadOpportunities[0];
    return `${sfLeadOpportunity.sfOpportunityId || ""}`;
  }
  if (crmIntegration === "DT") {
    const dtLeadOpportunity =
      opportunity?.dtLeadOpportunities?.length > 0 && opportunity?.dtLeadOpportunities[0];
    return `${dtLeadOpportunity.dtOpportunityId || ""}`;
  }
};

export const ABANDONED_CALL = "ABANDONED_CALL";

export const taskStatus = [
  {
    label: "Call",
    value: "CALL",
  },
  {
    label: "Follow up",
    value: "FOLLOW_UP",
  },
  {
    label: "Appointment",
    value: "APPOINTMENT",
  },
  {
    label: "Review Request",
    value: "REVIEW_REQUEST",
  },
  {
    label: "Text",
    value: "TEXT",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const TASK_STATUS_FILTER = [
  {
    label: "Call",
    value: "CALL",
  },
  {
    label: "Follow up",
    value: "FOLLOW_UP",
  },
  {
    label: "Appointment",
    value: "APPOINTMENT",
  },
  {
    label: "Review Request",
    value: "REVIEW_REQUEST",
  },
  {
    label: "Text",
    value: "TEXT",
  },
  {
    label: "Other",
    value: "OTHER",
  },
  {
    label: "Abandoned Call",
    value: ABANDONED_CALL,
  },
];

/**
 *
 * @param {string} htmlBody
 * @returns
 */
export function parseEmailReply(htmlBody) {
  // Simple input validation with optional chaining
  if (!htmlBody) {
    return {
      isReply: false,
      newMessage: "",
      originalMessage: null,
    };
  }

  const htmlString = typeof htmlBody === "string" ? htmlBody : htmlBody?.toString?.() || "";

  if (!htmlString?.trim?.()) {
    return {
      isReply: false,
      newMessage: "",
      originalMessage: null,
    };
  }

  // Define regex patterns as constants
  const REPLY_INDICATORS = [
    '<div class="gmail_quote">',
    "<blockquote",
    '<div class="OutlookMessageHeader">',
    "--- Original Message ---",
    "________________________________",
    "From:",
    "Sent:",
    "To:",
    // "Subject:",
  ];

  const HEAD_TAG_REGEX = /<head[^>]*>[\s\S]*?<\/head>/i;
  const HTML_TAG_REGEX = /<html[^>]*>/i;
  const XMLNS_ATTR_REGEX = /xmlns(:\w+)?="[^"]*"/g;
  const EMPTY_DIV_REGEX = /<div[^>]*>\s*<\/div>/g;
  const EMPTY_P_REGEX = /<p[^>]*>\s*<\/p>/g;
  const CONSECUTIVE_BR_REGEX = /<br\s*\/?>\s*<br\s*\/?>/g;
  const INLINE_STYLE_REGEX = /style="[^"]*"/g;
  const IMG_TAG_REGEX = /<img[^>]*>/gi;
  const UL_TAG_REGEX = /<ul[^>]*>([\s\S]*?)<\/ul>/gi;
  const OL_TAG_REGEX = /<ol[^>]*>([\s\S]*?)<\/ol>/gi;
  const BLOCKQUOTE_TAG_REGEX = /<blockquote[^>]*>/gi;
  const GMAIL_QUOTE_DIV_REGEX = /<div class="gmail_quote">/gi;

  // Safe string operations with optional chaining
  const lowerHtml = htmlString?.toLowerCase?.() || "";
  const isReply = REPLY_INDICATORS.some(indicator =>
    lowerHtml?.includes?.(indicator?.toLowerCase?.() || "")
  );

  if (!isReply) {
    return {
      isReply: false,
      newMessage: `\n${htmlString?.trim?.() || ""}`,
      originalMessage: null,
    };
  }

  function findEarliestReplyMarker() {
    let earliestIndex = htmlString?.length || 0;
    let foundIndicator = null;

    const lowerHtml = htmlString?.toLowerCase?.() || "";

    for (const indicator of REPLY_INDICATORS) {
      const index = lowerHtml?.indexOf?.(indicator?.toLowerCase?.() || "") ?? -1;
      if (index !== -1 && index < earliestIndex) {
        earliestIndex = index;
        foundIndicator = indicator;
      }
    }

    return { index: earliestIndex, indicator: foundIndicator };
  }

  const { index: splitIndex, indicator } = findEarliestReplyMarker();

  let newMessage = "";
  let originalMessage = "";

  if (splitIndex !== -1 && splitIndex < (htmlString?.length || 0)) {
    newMessage = htmlString?.substring?.(0, splitIndex)?.trim?.() || "";
    originalMessage = htmlString?.substring?.(splitIndex)?.trim?.() || "";

    const cleanHTML = html => {
      if (!html || typeof html !== "string") return "";

      return (
        html
          ?.replace?.(HEAD_TAG_REGEX, "") // Remove <head> tags and content
          ?.replace?.(
            HTML_TAG_REGEX,
            match => match?.replace?.(XMLNS_ATTR_REGEX, "")?.trim?.() || match
          )
          ?.replace?.(XMLNS_ATTR_REGEX, "") // Remove xmlns attributes from any tag
          ?.replace?.(/\n+/g, " ") // Replace multiple newlines with a single space
          ?.replace?.(EMPTY_DIV_REGEX, "") // Remove empty divs
          ?.replace?.(EMPTY_P_REGEX, "") // Remove empty paragraphs
          ?.replace?.(CONSECUTIVE_BR_REGEX, "<br>") // Remove consecutive <br> tags
          ?.replace?.(INLINE_STYLE_REGEX, match => {
            // Retain styles for specific elements
            if (match?.includes?.("font-size") || match?.includes?.("color")) {
              return match; // Keep styles for font size and color
            }
            return ""; // Remove other inline styles
          })
          ?.replace?.(/>\s+</g, "><") // Remove spaces between tags
          ?.replace?.(IMG_TAG_REGEX, match => {
            // Extract image src and style
            const src = match?.match?.(/src="([^"]*)"/)?.[1];
            if (!src) return match;
            // Add responsive styles while keeping original img tag
            return `<img src="${src}" style="max-width: 100%; width: auto; height: auto; display: block; margin: 8px 0;" />`;
          })
          ?.replace?.(UL_TAG_REGEX, match =>
            match
              ?.replace?.(/<ul[^>]*>/gi, '<ul style="padding-left: 20px; list-style-type: disc;">')
              ?.replace?.(/<li[^>]*>/gi, '<li style="margin: 5px 0;">')
          )
          ?.replace?.(OL_TAG_REGEX, match =>
            match
              ?.replace?.(/<ol[^>]*>/gi, '<ol style="padding-left: 20px;">')
              ?.replace?.(/<li[^>]*>/gi, '<li style="margin: 5px 0;">')
          )
          ?.replace?.(
            BLOCKQUOTE_TAG_REGEX,
            '<blockquote style="margin: 0 0 0 0.8ex; border-left: 1px solid #ccc; padding-left: 1ex; color: #666;">'
          ) // Retain blockquotes with improved styling
          ?.replace?.(
            GMAIL_QUOTE_DIV_REGEX,
            '<div class="gmail_quote" style="border-left: 1px solid #ccc; padding-left: 1ex; color: #666;">'
          ) // Retain Gmail quotes with improved styling
          ?.trim?.() || ""
      );
    };

    newMessage = `\n${cleanHTML(newMessage)}`;
    originalMessage = `\n${cleanHTML(originalMessage)}`;
  } else {
    // Fallback if splitting fails
    newMessage = `\n${htmlString?.trim?.() || ""}`;
    originalMessage = null;
  }

  return {
    isReply: true,
    newMessage: newMessage || null,
    originalMessage: originalMessage || null,
    replyIndicatorFound: indicator,
  };
}

function getAllKeys(jsonData) {
  const keys = new Set();

  function extractKeys(obj, parentKey = "") {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        // For nested objects
        extractKeys(obj[key], parentKey ? `${parentKey}_${key}` : key);
      } else {
        // For regular keys
        keys.add(parentKey ? `${parentKey}_${key}` : key);
      }
    }
  }

  // Process each item in the JSON array
  jsonData.forEach(item => extractKeys(item));

  return Array.from(keys);
}

// Function to get value from nested object using path
function getNestedValue(obj, path) {
  const keys = path.split("_");
  let value = obj;

  for (const key of keys) {
    if (value === null || value === undefined) return "";
    value = value[key];
  }

  // Handle arrays (like phoneNumbers and emails)
  if (Array.isArray(value)) {
    if (value.length === 0) return "";
    // Handle array of objects with specific properties
    if (value[0] && typeof value[0] === "object") {
      if (value[0].phone !== undefined) {
        return value
          .map(v => v?.phone)
          .filter(Boolean)
          .join(";");
      }
      if (value[0].email !== undefined) {
        return value
          .map(v => v?.email)
          .filter(Boolean)
          .join(";");
      }
    }
    return value.filter(Boolean).join(";");
  }

  return value || "";
}

// Function to convert JSON to CSV
export function convertJSONtoCSV(jsonData) {
  // Define the headers based on the data structure
  const headers = getAllKeys(jsonData);

  // Create CSV header row
  let csv = `${headers.join(",")}\n`;
  // Convert each JSON object to CSV row
  jsonData.forEach(item => {
    const row = headers
      .map(header => {
        const value = getNestedValue(item, header);
        // Escape and quote strings containing commas or quotes
        return typeof value === "string" ? `"${value.replace(/"/g, '""')}"` : value;
      })
      .join(",");

    csv += `${row}\n`;
  });

  return csv;
}

// Function to download CSV
export function downloadCSV(csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  // Create a URL for the blob
  const url = window.URL.createObjectURL(blob);

  // Set link properties
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `appointments-${convertUtcToLocal(dayjs(), "MM/DD/YYYY hh:mm A")}.csv`
  );

  // Append link to body, click it, and remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Validates and extracts an email address from a given string.
 * @param {string} input - The input string.
 * @returns {string} - Returns the valid email or an empty string if none found.
 */
export const getValidEmail = input => {
  // Return empty string if input is not a string
  if (!isString(input) || isEmpty(input)) return "";

  // Priority 1: Look for email within <...>
  const bracketEmailMatch = input.match(/<([^>]+)>/);
  if (bracketEmailMatch && isString(bracketEmailMatch[1])) {
    return bracketEmailMatch[1];
  }

  // Priority 2: Match any email in string
  const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
  const anyEmailMatch = input.match(emailRegex);
  return get(anyEmailMatch, 0, "");
};

/**
 * Checks if the message type is a campaign email
 * @param {string} type - The type of message to check
 * @returns {boolean} - Returns true if it's a campaign email
 */
export const isTypeOfCampaignEmail = type => {
  return type?.toLowerCase() === MESSAGE_CONTENT_TYPES.CAMPAIGN_MESSAGE_TO_LEAD.toLowerCase();
};

/**
 * Removes all leading "Fwd: " and "Re: " prefixes from content and adds a new prefix
 * @param {string} content - The input string to process
 * @param {string} prefix - The new prefix to add
 * @returns {string} - Content with removed email prefixes and new prefix added
 */
export const removeEmailPrefixesAndAddNew = (content, prefix = "") => {
  if (!isString(content) || isEmpty(content)) return prefix || "";

  // Remove any number of leading "Fwd: " and "Re: " case-insensitive prefixes
  const cleanedContent = content.replace(/^(Re: |Fwd: )+/i, "");

  // If no prefix to add, just return cleaned content
  if (!prefix) return cleanedContent;

  // Add new prefix
  return `${prefix} ${cleanedContent}`;
};

export const getOpportunityStatusPath = (statusList, statusId, joinBy = ">") => {
  if (!statusList || !statusList.length || !statusId) return "";

  // Create a map of statuses by ID for quick lookup
  const statusMap = {};
  (statusList || []).forEach(status => {
    statusMap[status.id] = status;
  });

  // If status ID doesn't exist in the map, return empty string
  if (!statusMap[statusId]) return "";

  // Build the path from target to root
  const path = [];
  let currentStatus = statusMap[statusId];

  // Add the current status name
  path.push(currentStatus?.name);

  // Traverse up the parent chain until we reach the root
  while (currentStatus?.parentStatusId) {
    currentStatus = statusMap[currentStatus.parentStatusId];
    if (!currentStatus) break; // Safety check in case of bad data
    path.push(currentStatus.name);
  }

  // Reverse the path to get parent > child > grandchild order
  return path.reverse().join(` ${joinBy} `);
};

export const getUniqueVehicleOfInterest = vehicleOfInterest => {
  return uniqBy(vehicleOfInterest || [], v => [v.year, v.make, v.model, v.customerInterest].join());
};

export const getVehicleName = vehicle => {
  if (!isEmpty(vehicle)) {
    const { make, model, year } = vehicle;
    // A YMM part is only meaningful if it isn't empty/zero AND isn't a
    // placeholder like "unknown" — the BE sends literal "unknown" for missing
    // make/model, which would otherwise render as "unknown unknown".
    const isValidVoiPart = item => {
      if (item === null || item === undefined) return false;
      const s = String(item).trim().toLowerCase();
      return s !== "" && s !== "0" && s !== "unknown";
    };
    const vehicleParts = [year, make, model].filter(isValidVoiPart);
    return vehicleParts.join(" ");
  }
  return "";
};

// Sent to GET_ENGAGEMENT_TEMPLATE_TEXT, which expands {createAppointmentUrl}
// into the shortened booking link in place.
export const APPOINTMENT_LINK_TEMPLATE = "Schedule appointment here: {createAppointmentUrl}";

/**
 * Builds a DocumentFragment for content whose lines are either a bare URL or a
 * label followed by a URL — e.g. "2020 Acura ILX Base - check details here:
 * https://…" or "Schedule appointment here: https://…". The label stays plain
 * text and only the URL becomes an anchor, so the rich-text editor doesn't
 * hyperlink the whole sentence.
 *
 * @param {string} content
 * @returns {DocumentFragment}
 */
export const buildLinkedContentFragment = content => {
  const fragment = document.createDocumentFragment();
  (content || "").split("\n").forEach(line => {
    const trimmed = line.trim();
    if (!trimmed) return;
    const [url] = trimmed.match(/https?:\/\/\S+$/) || [];
    if (url) {
      const label = trimmed.slice(0, trimmed.length - url.length);
      if (label) fragment.appendChild(document.createTextNode(label));
      const linkNode = document.createElement("a");
      linkNode.href = url;
      linkNode.textContent = url;
      linkNode.target = "_blank";
      fragment.appendChild(linkNode);
    } else {
      fragment.appendChild(document.createTextNode(trimmed));
    }
    fragment.appendChild(document.createElement("br"));
  });
  return fragment;
};

export const MESSAGE_TYPES = Object.freeze({
  WEBCHAT_WIDGET: "WIDGET_CHAT",
});

export const INPUT_TAB_HEIGHT = {
  DEFAULT_TEXT_MESSAGE: 135,
  DEFAULT_EMAIL: 360,
  MAX_TEXT_MESSAGE: 600,
  MAX_EMAIL: 600,
  MIN_TEXT_MESSAGE: 135,
  MIN_EMAIL: 230,
};

// AWS SES caps an outgoing email at 10 MiB after MIME encoding.
// Base64 inflates binary attachments by ~1.37x, and the HTML body +
// MIME headers eat additional bytes, so we cap raw attachment bytes at
// 7 MiB to leave headroom under the 10 MiB ceiling.
export const EMAIL_ATTACHMENT_LIMITS = {
  MAX_RAW_BYTES: 7 * 1024 * 1024,
};

const escapeHtml = value =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Greedy-pack uploads (smallest first) into an "inline" bucket while the
// running total stays under the SES-safe limit. Anything that doesn't fit
// goes into the "links" bucket and will be appended to the email body as
// download links instead of being base64-attached to the MIME message.
export const partitionAttachmentsForEmail = (uploads, maxRawBytes) => {
  if (!Array.isArray(uploads) || uploads.length === 0) {
    return { inline: [], links: [] };
  }
  const sorted = [...uploads].sort((a, b) => (a?.size || 0) - (b?.size || 0));
  const inline = [];
  const links = [];
  let running = 0;
  for (const item of sorted) {
    const size = item?.size || 0;
    if (running + size <= maxRawBytes) {
      inline.push(item);
      running += size;
    } else {
      links.push(item);
    }
  }
  return { inline, links };
};

export const buildAttachmentLinksHtml = links => {
  if (!Array.isArray(links) || links.length === 0) return "";
  const items = links
    .map(link => {
      const url = escapeHtml(link?.mediaUrl || "");
      const name = escapeHtml(link?.filename || "Attachment");
      const size = link?.size ? ` (${formatBytes(link.size)})` : "";
      return `<li style="margin:4px 0;"><a href="${url}" target="_blank" rel="noopener noreferrer">${name}</a>${size}</li>`;
    })
    .join("");
  return `<br/><div><p style="margin:8px 0 4px 0;"><strong>Attachments:</strong></p><ul style="padding-left:20px;margin:0;">${items}</ul></div>`;
};

// Splits an array of S3-uploaded attachments into the payload `attachments`
// (small enough to inline) and an HTML snippet to append to the body for
// the rest. Strips local-only fields like `filename` from the inline list.
export const buildEmailAttachmentsPayload = (uploads, content, maxRawBytes) => {
  const { inline, links } = partitionAttachmentsForEmail(uploads, maxRawBytes);
  const inlineForApi = inline.map(({ filename, ...rest }) => rest);
  const linksHtml = buildAttachmentLinksHtml(links);
  return {
    attachments: inlineForApi,
    content: linksHtml ? `${content || ""}${linksHtml}` : content || "",
    linkedCount: links.length,
  };
};

/**
 * Picks the social-review setting that belongs to the active opportunity-type
 * tab from the list returned by `getSocialReviewSettings`.
 *
 * A location can have several review settings — some scoped to a specific
 * opportunity type (`opportunityTypeId`), some unscoped (`opportunityTypeId`
 * is null). Callers previously just took `reviewInfos[0]`, which could pick a
 * setting belonging to a different tab (or an inactive one).
 *
 * Selection rules:
 *  1. Exactly one record matches `selectedOppTypeId` -> use it, regardless of
 *     `isActive` (an explicit match wins).
 *  2. Multiple records match -> prefer the first with `isActive: true`;
 *     if none are active, use the first matched record.
 *  3. No record matches (e.g. every record has a null `opportunityTypeId`) ->
 *     fall back to the first `isActive: true` record, else the first record.
 *
 * @param {Array<object>} reviewInfos       getSocialReviewSettings result
 * @param {number|string} selectedOppTypeId Active root opportunity-type id
 * @returns {object|null} The chosen review setting, or null when the list is empty.
 */
export const resolveReviewInfoByOppType = (reviewInfos, selectedOppTypeId) => {
  const list = (Array.isArray(reviewInfos) ? reviewInfos : []).filter(Boolean);
  if (list.length === 0) return null;

  // Ids arrive as numbers here but as strings elsewhere — compare numerically.
  const matched =
    selectedOppTypeId === null || selectedOppTypeId === undefined
      ? []
      : list.filter(
          item =>
            item?.opportunityTypeId !== null &&
            item?.opportunityTypeId !== undefined &&
            +item.opportunityTypeId === +selectedOppTypeId
        );

  // 1) Single explicit match — use it as-is (active or not).
  if (matched.length === 1) return matched[0];

  // 2) Several matches — prefer an active one, else the first match.
  if (matched.length > 1) return matched.find(item => item?.isActive) || matched[0];

  // 3) No match (all unscoped, or scoped to other tabs) — first active, else first.
  return list.find(item => item?.isActive) || list[0];
};
